<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ddlHelper, sessionHelper, sharedHelper } from "@/utils";
import { SESSION } from "@/constants";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import i18n from '@/i18n'
import { LOOKUP_MODULE } from '@/state/modules/lookup'
import { PRODUCT_SNS_MODULE } from '@/state/modules/productSNS'
import { lookupMethods, productSNSMethods } from "@/state/helpers";
import Multiselect from "vue-multiselect";
import ImageUploader from '@/components/upload-file';

export default {
    page: {
        title: i18n.t("label.updateX", [i18n.t("module.productSNS")]),
    },
    components: { Layout, PageHeader, Multiselect, ImageUploader },
    beforeRouteLeave(to, from, next) {
        if (to.name != "Product-sns-listing") {
            sessionHelper.clearSearch(SESSION.PRODUCT_SNS_SEARCH);
        }
        next();
    },
    computed: {
        ...mapState(PRODUCT_SNS_MODULE, ["status"]),
        ...mapState(LOOKUP_MODULE),
        productDdl() {
            return this.$store.state.lookup.productDdl;
        },
    },
    data() {
        return {
            title: i18n.t("label.createX", [i18n.t("module.productSNS")]),
            items: [
                {
                    text: i18n.t('module.dashboard'),
                    href: "/",
                },
                {
                    text: i18n.t("module.productSNS"),
                    href: "/product-sns",
                },
                {
                    text: i18n.t("label.createX", [i18n.t("module.productSNS")]),
                    active: true,
                },
            ],
            submitted: false,
            statusDdl: ddlHelper.getActivationStatus(false, true),
            selectedOffDays: [], // This will hold the full objects selected in the multiselect
            weekDayDdl: ddlHelper.getWeekDays(),
            permissions: sessionHelper.getPermissions(),
            createPermission: null,
            isCloseWhenSuccess: false, 
            createForm: {
                name: "",
                productID: "",
                file: "",
            },
        };
    },
    validations: {
        createForm: {
            // name: { required },
            productID: { required }
        },
    },
    async created() {
        await this.validPermissions();
        this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PRODUCT_SPECIAL_SEARCH);
        await this.lookupProduct({ hasOptionAll: false });

        if (this.searchCriteria != null) {
            this.createForm.productID = this.$store.state.lookup.productDdl.filter(item => item.value === this.searchCriteria.selectedRecordId);

            if( this.createForm.productID != null && this.createForm.productID.length > 0) {
                this.isCloseWhenSuccess = true; 
            }

            if (this.searchCriteria != null && this.searchCriteria != '' && this.searchCriteria.selectedRecordId == null) {
                sharedHelper.alertErrorMessageWithoutCode("Invalid Product ID, Please Contact Admin")
            }
        }
    },
    methods: {
        ...productSNSMethods,
        ...lookupMethods,
        async validPermissions() {
            var jsonPermissions = JSON.parse(this.permissions)
            if (jsonPermissions.some(p => p.code === "RND_PSDS_PSDSC")) {
                this.createPermission = true;
            }
            else {
                this.createPermission = false;
            }
        },
        updateImage(image) {
            this.createForm.file = image[0].file;
        },
        removeImage() {
            this.createForm.file = null;
        },
        async requestCreate() {
            this.submitted = true;
            // stop here if form is invalid
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            } else {
                let isCloseWhenSuccess = this.isCloseWhenSuccess;
                let data = {
                    name: this.createForm.name,
                    productID: this.isCloseWhenSuccess == true ? this.createForm.productID[0].value : this.createForm.productID.value,
                    file: this.createForm.file,
                };

                if (this.createPermission == true) {
                    await this.createProductSNS({ data, isCloseWhenSuccess });
                }
            }
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <form @submit.prevent="requestCreate" v-if="createPermission == true">
                            <ImageUploader :showImageTop="true" :buttonText="'Choose Product Cert'" @images-removed="removeImage"
                                @images-changed="updateImage" />

                            <div class="row">
                                <div class="col-md-6">
                                    <b-form-group id="productID" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('module.product')" label-for="productID">
                                        <multiselect v-model="createForm.productID"
                                            deselect-label="Can't remove this value" track-by="value" label="text"
                                            placeholder="Select one" :options="productDdl" :searchable="true"
                                            :allow-empty="false">
                                        </multiselect>
                                        <div v-if="submitted && !$v.createForm.productID.required"
                                            class="invalid-feedback" style="display: block;">
                                            <span>{{ $t("message.requiredX", [$t("module.product")]) }}</span>
                                        </div>
                                    </b-form-group>
                                </div>

                                <!-- <div class="col-md-6">
                                    <b-form-group id="name" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('label.name')" label-for="name">
                                        <b-form-input id="name" v-model.trim="createForm.name" :class="{
                                            'is-invalid': submitted && !$v.createForm.name.required
                                        }"></b-form-input>
                                        <div v-if="submitted && !$v.createForm.name.required" class="invalid-feedback"
                                            style="display: block;">
                                            <span>{{ $t("message.requiredX", [$t("label.name")]) }}</span>
                                        </div>
                                    </b-form-group>
                                </div> -->

                            </div>

                            <div class="mt-4 text-center" style="float: right">
                                <button class="btn btn-primary w-md waves-effect waves-light" style="margin-right: 10px"
                                    type="submit" :disabled="status.create">
                                    {{ $t("label.createX", [$t("module.productSNS")]) }}
                                </button>
                            </div>
                        </form>
                        <div style="text-align: center;" v-else>
                            {{ $t('message.noPermissionMessage') }}
                        </div>
                    </div>
                </div>
                <!-- end card -->
            </div>
            <!-- end col -->
        </div>
    </Layout>
</template>